// extracted by mini-css-extract-plugin
export default {"EditionSupprimerRdv":"EditionSupprimerRdv_EditionSupprimerRdv__gGeK0","Choix":"EditionSupprimerRdv_Choix__FjtBD","Etiquette":"EditionSupprimerRdv_Etiquette__dh7hn"};